import WhiteboardControllerInterface from "@/wbcontroller/types/WhiteboardControllerInterface";

export default function renderAndDownloadImage(
  wb: WhiteboardControllerInterface,
  scaleFactor: number,
  transparentBackground: boolean,
  progressCb: (progress: number) => void,
  finishCb: (url: string) => void
) {
  const urlPromise = wb.render(scaleFactor, transparentBackground, progressCb);
  urlPromise.then((url: string) => {
    if (!url) return;
    finishCb(url);
  });
}
